import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  ApprovalListRequestModel,
  ApprovalListSortColumn,
  ApprovalSearchStatusEnum,
  SortOrderEnum,
} from 'api/changeofownership'
import { RootState } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'

export type NewOwnersFilters = Omit<ApprovalListRequestModel, 'clientId'> &
  Required<Pick<ApprovalListRequestModel, 'skip' | 'take'>>

export const newOwnersInitialFilters: NewOwnersFilters = {
  searchText: '',
  searchStatus: ApprovalSearchStatusEnum.All,
  sortColumn: ApprovalListSortColumn.HandoverDate,
  sortOrder: SortOrderEnum.Descending,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
}

const newOwnersFiltersSlice = createSlice({
  name: 'newOwnersFilters',
  initialState: newOwnersInitialFilters,
  reducers: {
    patchNewOwnersFilters: (
      state,
      action: PayloadAction<Partial<NewOwnersFilters>>
    ) => ({ ...state, ...action.payload }),
  },
})

export const getNewOwnersFilters = (state: RootState) => state.newOwnersFilters

export const { patchNewOwnersFilters } = newOwnersFiltersSlice.actions

export default newOwnersFiltersSlice
